import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormControl, FormControlLabel, Typography } from '@mui/material';
import { RIStyles, CustomRadioGroup, CustomRadio } from 'pages/reference-implementation/Style';

const ReadAccessRadioBtn = (props) => {
    const { isReadAccessValue, handleOnSelect, isRequired } = props;
    return (
        <Box>
            <Typography sx={RIStyles?.configuration?.cosmos?.heading}>Do You have Read Access Service Account?</Typography>
            <FormControl error={isRequired}>
                <CustomRadioGroup
                    aria-label="consumerGroup"
                    name="consumergroupRadioBtnGroup"
                    row
                    value={isReadAccessValue}
                    onChange={(event, value) => {
                        handleOnSelect(value);
                    }}
                >
                    <FormControlLabel
                        value="Yes"
                        control={
                            <CustomRadio
                                sx={{
                                    color: `${isRequired ? '#d40020' : '#0047BA'}`,
                                }}
                            />
                        }
                        label="Yes"
                        data-testid="readAccessYes"
                    />
                    <FormControlLabel
                        value="No"
                        sx={{
                            marginLeft: '60px',
                        }}
                        control={
                            <CustomRadio
                                sx={{
                                    color: `${isRequired ? '#d40020' : '#0047BA'}`,
                                }}
                            />
                        }
                        label="No"
                        data-testid="readAccessNo"
                    />
                </CustomRadioGroup>
                {/* {isRequired && <FormHelperText sx={{ color: '#d40020' }}>Read Access is Required</FormHelperText>} */}
            </FormControl>
        </Box>
    );
};

ReadAccessRadioBtn.propTypes = {
    isReadAccessValue: PropTypes.any,
    handleOnSelect: PropTypes.func,
    isRequired: PropTypes?.bool,
};

ReadAccessRadioBtn.defaultProps = {
    isReadAccessValue: 'no',
    handleOnSelect: () => {},
    isRequired: false,
};

export default ReadAccessRadioBtn;
